export default __webpack_public_path__ + "e278cadcef17bca51263def0b30242c6.webp";